import { Suspense } from 'react';

import { ProfileDropdownLoader } from './profile-dropdown-loader';
import { ProfileDropdownServer } from './profile-dropdown-server';
import { type ProfileDropdownProps } from './types';

export const ProfileDropdownSuspenseWrapper = async (props: ProfileDropdownProps) => {
  return (
    <Suspense fallback={<ProfileDropdownLoader />}>
      <ProfileDropdownServer {...props} />
    </Suspense>
  );
};
